// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { RegistrarServiceRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Service/Registrar';
import { CreateEvent } from '@daml/ledger';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';

const useRequestRegistrarService: () => UseMutationResult<
  CreateEvent<RegistrarServiceRequest>,
  string,
  {
    provider: string;
  }
> = () => {
  const ledgerApi = useLedgerApiClient();
  const { operator, party } = useParties();

  return useMutation({
    mutationKey: ['requestRegistryRegistrarService', ledgerApi, operator, party],
    mutationFn: async ({ provider }) => {
      return ledgerApi.requestRegistryRegistrarService(operator, provider, party);
    },
  });
};

export default useRequestRegistrarService;
